import {useState} from 'react';

export const SingleProductFocusMultipleVariantSelectors = ({
  alternativeVariantSelector,
  primaryVariantSelector
}) => {
  const [selector, setSelector] = useState('primary');

  return (
    <div className={'mt-8'}>
      <div className={'mb-2 text-md lg:text-md font-bold uppercase'}>Buying Options</div>
      <div className={`flex justify-start gap-4 items-center`}>
        <div
          onClick={() => setSelector('primary')}
          className={`border border-neutral-400 font-medium px-2 py-1 lg:px-4 lg:py-2 hover:bg-gray-100 cursor-pointer rounded border-neutral-500  ${
            selector === 'primary' ? 'bg-neutral-200 hover:bg-neutral-200' : ''
          }`}>
          {alternativeVariantSelector?.MainTitle}
        </div>
        <div
          onClick={() => setSelector('secondary')}
          className={`border border-neutral-400 font-medium px-2 py-1 lg:px-4 lg:py-2 hover:bg-gray-100 cursor-pointer rounded border-neutral-500 ${
            selector === 'secondary' ? 'bg-neutral-200 hover:bg-neutral-200' : ''
          }`}>
          {alternativeVariantSelector?.AlternateTitle}
        </div>
      </div>

      <div className={`mt-4 ${selector === 'primary' ? 'block' : 'hidden'}`}>
        {primaryVariantSelector}
      </div>

      <div className={`mt-4 ${selector === 'secondary' ? 'block' : 'hidden'}`}>
        {alternativeVariantSelector?.component}
      </div>
    </div>
  );
};
